import {normalizeDecimalValue} from './normalizeDecimalValue';

export function areDecimalValuesEqual(left: string | null, right: string | null) {
  return normalizeDecimalValue(left) === normalizeDecimalValue(right);
}
